import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { useTranslation } from "../../contexts/TranslationContext";

import "../../assets/css/landing.css";
import "../../assets/css/brand.css";

/**
 * Slim chrome for the public legal pages. The marketing navigation lives with
 * the site itself, which is not published yet — the landing route is a
 * coming-soon page.
 */
export default function Header() {
  const { toggleLanguage, language, isRTL } = useTranslation();

  // landing.css is bundled globally; scope its resets to landing routes only so
  // they never leak into the admin portal.
  useEffect(() => {
    document.body.classList.add("landing-page");
    return () => document.body.classList.remove("landing-page");
  }, []);

  return (
    <nav
      className="navbar navbar-expand-lg px-5"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Padel Kingdom" className="logo" style={{ height: "52px", width: "auto" }} />
        </Link>

        <button
          type="button"
          className={`lang-switch ${language === "ar" ? "is-ar" : "is-en"}`}
          onClick={toggleLanguage}
          aria-label="Switch language"
        >
          <span className="lang-switch-knob">{language === "eng" ? "EN" : "AR"}</span>
        </button>
      </div>
    </nav>
  );
}
